export default __webpack_public_path__ + "static/media/tituloES.c2670c6e.png";